import React, { memo, useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import useOnClickOutside from 'hooks/useOnClickOutside';

import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export const defaultDataForContextMenu = {
  text: '',
  shapeRef: null,
};

const ContextMenu = ({ onClose, onClickCopy }) => {
  const contextMenuRef = useRef();

  // canvas clear area invoked before onCLick callback
  const stopEventPropagate = useCallback((e) => e.stopPropagation(), []);

  // TODO: make dynamic handlers if more than one item
  const onClickItem = useCallback(() => {
    onClickCopy();
    onClose?.();
  }, [onClickCopy, onClose]);

  useOnClickOutside(contextMenuRef, onClose);

  return (
    <Paper ref={contextMenuRef} onClick={stopEventPropagate} onMouseDown={stopEventPropagate}>
      <MenuList disablePadding>
        <MenuItem onClick={onClickItem} role="button" tabIndex={0} onKeyUp={onClickItem}>
          <ListItemIcon>
            <ContentCopyIcon color="primary" />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage id="document.polygon.contextMenu.copy" defaultMessage="Copy" />
          </ListItemText>
        </MenuItem>
      </MenuList>
    </Paper>
  );
};

export default memo(ContextMenu);
